import { render, staticRenderFns } from "./StyleDialogContentClass.vue?vue&type=template&id=0f700fce&scoped=true&"
import script from "./StyleDialogContentClass.vue?vue&type=script&lang=js&"
export * from "./StyleDialogContentClass.vue?vue&type=script&lang=js&"
import style0 from "./StyleDialogContentClass.vue?vue&type=style&index=0&id=0f700fce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f700fce",
  null
  
)

export default component.exports